import { Typography } from 'enova-frontend-components';
import styled from 'styled-components';

export const ViewActionTypography = styled(Typography)`
  padding-bottom: 16px;
  white-space: pre-line;
`;
